import axios from 'axios';
import { JwtService } from './jwtService';

const base_url = process.env.REACT_APP_API_URL;
const LOGIN_PATH = '/login';

const api = axios.create({
  baseURL: `${base_url}/bff`,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const isLoginRequest = (url?: string) => !!url && url.endsWith(LOGIN_PATH);

const handleLogout = () => {
  JwtService.clear();
  window.location.href = '/login';
};

api.interceptors.request.use(
  request => {
    const token = JwtService.getJwt();
    if (!request.headers.Authorization && token) {
      request.headers.Authorization = `Bearer ${token}`;
    }
    return request;
  },
);


api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && !isLoginRequest(error.config?.url)) {
      handleLogout();
    }
    return Promise.reject(error);
  },
);

export default api;
